import Provider from '@solvhealth/types/interfaces/Provider';

const sanitizeUri = (uri: any) => {
  if (uri) {
    return uri
      .toString()
      .replace("'", '-')
      .replace(/\s/gi, '-')
      .replace(/[^a-z0-9-]/gim, '');
  }

  return null;
};

export const createProviderUrlFromProvider = (provider?: Provider) => {
  if (provider) {
    const name = [provider.first_name, provider.last_name]
      .map((name) => name.toLowerCase())
      .join(' ');
    const { id } = provider;
    return `/provider/${[name, id].map(sanitizeUri).join('-')}`;
  }

  return '';
};
